import EchartsTool from './echartsTool.js'

/**
 * 带折线
 * 
 * 胶囊图
 * 
 * 呼吸率变快
 */

import * as echarts from 'echarts';

export default function getEchartsOptionFloatA2(
	xAxis_data,
	series_data,
	expansion_data,
	markArea_range,
	isDifferentColors,
	colorArr
) {
	// pieces
	let pieces = isDifferentColors ? EchartsTool.get_line_visual_map_pieces_3( xAxis_data, colorArr) :  EchartsTool.get_line_visual_map_pieces_4( xAxis_data, colorArr);


	// markArea_data
	let markArea_data = (markArea_range && markArea_range.length == 2) ? [
		[
			{ yAxis: markArea_range[0] },
			{ yAxis: markArea_range[1] },
		]
	] : undefined;

	let markLine_data = (markArea_range && markArea_range.length == 2) ? [
		{
			yAxis: markArea_range[0]
		},
		{
			yAxis: markArea_range[1]
		}
	] : undefined


	let option = {
		color: "#1890ff",
		grid: {
			x: 15,
			y: 15,
			x2: 15,
			y2: 10,
			containLabel: true
		},
		tooltip: {
			trigger: "axis",
			backgroundColor: "rgba(255, 255, 255, 1)",
			borderColor: "rgba(24, 144, 255, 0.6)",
			borderWidth: 1,
			spanStyle: {
				color: "#fff",
			},
			trigger: "axis",
			confine: true,
			borderRadius: 5,
			textStyle: {
				color: '#8394B9',
				fontSize: 14
			},
			formatter: function (params) {
				// 获取日期
				let date = expansion_data[params[0].dataIndex] || '';

				// 获取最高、最低、平均
				let max = '最高：' + (params[0].value == '-' ? '-' : parseInt(params[0].value) + parseInt(params[1].value)) + (params[0].value == '-' ? '' : '次/分');
				let min = '最低：' + (params[0].value == '-' ? '-' : params[0].value) + (params[0].value == '-' ? '' : '次/分');
				let avg = '平均：' + (params[0].value == '-' ? '-' : params[2].value) + (params[0].value == '-' ? '' : '次/分');

				// 区分颜色
				let dotColor = 'rgba(74, 124, 232, 1)';
				let textColor = 'rgba(131, 148, 185, 1)';
				if (EchartsTool.get_deal_color_arr_1(xAxis_data, colorArr)[params[0].dataIndex] == 1) {
					dotColor = 'rgba(255, 113, 134, 1)';
					textColor = 'rgba(255, 113, 134, 1)';
				}

				// 弹窗样式
				let titleDiv = `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${date}</div>`
				let contentDiv1 = `
				<div style="display: flex; align-items: center; margin-top: 5px;">
					<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
					<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${max}</div>
				</div>
				`
				let contentDiv2 = `
				<div style="display: flex; align-items: center; margin-top: 5px;">
					<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
					<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${min}</div>
				</div>
				`
				let contentDiv3 = `
				<div style="display: flex; align-items: center; margin-top: 5px;">
					<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
					<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${avg}</div>
				</div>
				`
				return titleDiv + contentDiv1 + contentDiv2 + contentDiv3;
			},
		},
		xAxis: [
			{
				type: "category",
				data: xAxis_data,
				axisLine: {
					lineStyle: {
						color: "#c7c6c9",
					},
				},
				axisLabel: {
					textStyle: {
						color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
						fontSize: 10
					},
				},
				axisTick: {
					show: false,
					alignWithLabel: true,
				},
				show: true,
			},
		],
		yAxis: [
			{
				// min: 40,
				type: "value",
				splitLine: {
					show: true,
				},
				axisLine: {
					lineStyle: {
						color: "#c7c6c9",
					},
					show: false,
				},
				axisLabel: {
					textStyle: {
						color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
						fontSize: 10
					},
				},
				splitNumber: 2,
			},
		],
		visualMap: {
			show: false,
			dimension: 0,
			seriesIndex: 3,
			pieces: pieces
		},
		series: [
			{
				stack: "float",
				type: "bar",
				barGap: "-100%",
				itemStyle: {
					normal: {
						barBorderColor: "rgba(0,0,0,0)",
						color: "rgba(0,0,0,0)",
					},
					emphasis: {
						barBorderColor: "rgba(0,0,0,0)",
						color: "rgba(0,0,0,0)",
					},
				},
				data: series_data[0].data,
				markArea: {
					itemStyle: {
						color: 'rgba(74, 124, 232, 0.05)',
						lineStyle: {
							type: "dashed",
							color: "#8287F4",
						},
						// borderColor: "#9EB8F1",
						// borderWidth: 1.8,
						// borderType: 'dotted',
					},
					data: markArea_data,
				},
				markLine: {
						zIndex: -1,
						symbol: ['none', 'none'],
						label: {
						show: false
						},
						lineStyle: {
							color: '#9EB8F1'
						},
						emphasis: {
							disabled: true // 关闭高亮
						},
						data: markLine_data
				},
				barWidth: 22
			},
			{
				z: 5,
				stack: "float",
				type: "bar",
				barGap: "-100%",
				itemStyle: {
					normal: {
						barBorderRadius: [4, 4, 4, 4],
						barBorderColor: "rgba(0,0,0,0)",
						color: function(params) {
							if (isDifferentColors) {
								if (colorArr && colorArr.length > 0) {
									if (colorArr[params.dataIndex] == 0) {
										if (params.dataIndex == series_data[1].data.length - 1) {
											return 'rgba(74, 124, 232, 1)'
										}
										return 'rgba(74, 124, 232, 0.2)'
									} else {
										if (params.dataIndex == series_data[1].data.length - 1) {
											return 'rgba(255, 113, 134, 1)'
										}
										return 'rgba(255, 113, 134, 0.1)'
									}
								} else {
									return 'rgba(74, 124, 232, 0.1)'
								}
							} else {
								return 'rgba(74, 124, 232, 0.1)'
							}
						}
					},
				},
				data: series_data[1].data,
				barWidth: 22
			},
			{
				z: 0,
				type: "bar",
				barGap: "-100%",
				itemStyle: {
					normal: {
						barBorderColor: "rgba(0,0,0,0)",
						color: "rgba(0,0,0,0)",
					},
					emphasis: {
						barBorderColor: "rgba(0,0,0,0)",
						color: "rgba(0,0,0,0)",
					},
				},
				data: series_data[2].data,
				barWidth: 22
			},
			{
				z: 6,
				data: series_data[2].data,
				type: 'line',
				symbol: 'circle',
				symbolSize: 8,
				color: 'rgba(74, 124, 232, 1)',
				itemStyle: {
					normal: {
						borderWidth: 1.5,
						borderColor: 'rgba(233, 238, 250, 1)'
					},
				},
				emphasis: {
					scale: 1.5
				}
			}
		],
	};
	
	return option;
}